/* eslint-disable import/prefer-default-export */
import React from "react"

export const LandingPageContext = React.createContext({
  page: "home",
  setBackgroundMode: mode => {},
})
